module.exports = __webpack_public_path__ + "static/media/contentful.32853840.svg";